// Generated by ScalaTS 0.8.2: https://scala-ts.github.io/scala-ts/

declare var exports: any;

export const nsRejected = exports;

export const RejectedInhabitant = 'Rejected';

export type Rejected = typeof RejectedInhabitant;

export function isRejected(v: any): v is Rejected {
  return RejectedInhabitant == v;
}

export type RejectedSingleton = Rejected;
